import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../firebase';
import './Navbar.css';
import logo from '../assets/arcanes_new_home_logo.png';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [b2bOpen, setB2bOpen] = useState(false);
  const [exploreOpen, setExploreOpen] = useState(false);

  useEffect(() => {
    return onAuthStateChanged(auth, setUser);
  }, []);

  const hideButtons = ['/create', '/configure'].includes(location.pathname);

  const handleCreate = () => {
    if (!user) {
      if (window.confirm('Please log in to create AI. Log in now?')) navigate('/login');
      return;
    }
    navigate('/create');
  };

  const handleMyAgents = () => {
    if (!user) {
      if (window.confirm('Please log in to view My Agents. Log in now?')) navigate('/login');
      return;
    }
    navigate('/myagents');
  };

  const handleSignOut = async () => {
    if (window.confirm('Sign out?')) {
      await signOut(auth);
      navigate('/');
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" className="logo-link">
          <img src={logo} alt="Logo" className="logo" />
        </Link>
        <Link to="/about" className="nav-link no-underline">About Us</Link>

        <div
          className="nav-link dropdown-trigger"
          onMouseEnter={() => setExploreOpen(true)}
          onMouseLeave={() => setExploreOpen(false)}
        >
          Explore Agents
          {exploreOpen && (
            <div className="dropdown-menu">
              {!hideButtons && user && (
                <button
                  className={`dropdown-item${location.pathname === '/myagents' ? ' active' : ''}`}
                  onClick={handleMyAgents}
                >
                  My Agents
                </button>
              )}
              <button
                className="dropdown-item"
                onClick={() => navigate('/agents-hub')}
              >
                Agents Hub
              </button>
            </div>
          )}
        </div>

        <div
          className="nav-link dropdown-trigger"
          onMouseEnter={() => setB2bOpen(true)}
          onMouseLeave={() => setB2bOpen(false)}
        >
          B2B Solutions
          {b2bOpen && (
            <div className="dropdown-menu">
              <button
                className="dropdown-item"
                onClick={() => navigate('/b2b/modular')}
              >
                Modular B2B Solutions
              </button>
              <button
                className="dropdown-item"
                onClick={() => navigate('/b2b/tailored')}
              >
                1:1 B2B Solutions
              </button>
              <button
                className="dropdown-item"
                onClick={() => navigate('/b2b/use-cases')}
              >
                Use Cases
              </button>
              
              <button className="dropdown-item" onClick={() => navigate('/b2b/quote')}>🔐 Access Your Quote</button>
            </div>
          )}
        </div>
      </div>

      {!hideButtons && (
        <div className="navbar-right">
          <button className="btn-create" onClick={handleCreate}>
            + Create
          </button>
          {user
            ? <button className="btn-auth" onClick={handleSignOut}>Sign Out</button>
            : <button className="btn-auth" onClick={() => navigate('/login')}>Log In</button>
          }
        </div>
      )}
    </nav>
  );
}
